import { render, staticRenderFns } from "./athlete-registration-print.vue?vue&type=template&id=6c515af1&scoped=true&"
import script from "./athlete-registration-print.vue?vue&type=script&lang=js&"
export * from "./athlete-registration-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c515af1",
  null
  
)

export default component.exports